import { useEffect, useState } from 'react'

/** Der Worker hat eine Speicherung abgewiesen, weil Test nur liest; `detail` ist seine Meldung. */
export const NUR_LESEN_EVENT = 'k4ia:nur-lesen'

let gemerkt: string | null = null

/**
 * In welcher Umgebung läuft dieses Admin? Aus `/api/v1/health` des
 * API-Workers (über die Service-Bindung), einmal je Seite. `null`, solange
 * die Antwort aussteht — dann zeigt das Admin noch keinen Streifen.
 */
export function useUmgebung(): string | null {
  const [umgebung, setUmgebung] = useState<string | null>(gemerkt)
  useEffect(() => {
    if (gemerkt) return
    let aktiv = true
    fetch('/api/v1/health', { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((body: { environment?: string } | null) => {
        if (!aktiv || typeof body?.environment !== 'string') return
        gemerkt = body.environment
        setUmgebung(gemerkt)
      })
      .catch(() => {})
    return () => {
      aktiv = false
    }
  }, [])
  return umgebung
}
